(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3MergeMember', {
            templateUrl: 'app/member-admin/merge-member/merge-member.component.html',
            controller: MergeMemberComponent,
            bindings: {
                primaryMember: '<'
            }
        });

    var noop = angular.noop;

    MergeMemberComponent.$inject = ['$scope', '$state', 'Member', 'confirm', 'alert', 'memberAdminResources'];
    function MergeMemberComponent($scope, $state, Member, confirm, alert, resources) {
        var ctrl = this;
        ctrl.secondaryMember = null;
        ctrl.select = select;
        ctrl.mergeAccounts = mergeAccounts;

        function select(e, member) {
            e.preventDefault();
            ctrl.secondaryMember = member;
        }

        function mergeAccounts() {
            confirm(resources.confirmMergeAccounts).then(mergeMembers, noop);

            function mergeMembers() {
                var primaryId = ctrl.primaryMember.individualId,
                    secondaryId = ctrl.secondaryMember.individualId;

                Member.mergeAccounts({ id: primaryId }, { id: secondaryId }, success, error, true);

                function success() {
                    $scope.$emit('$userChanged');
                    alert.success(resources.mergeAccountsSucceeded).then(gotoScoreHistory, noop);
                }
                function error() {
                    alert.error(resources.mergeAccountsFailed);
                }

                function gotoScoreHistory() {
                    $state.go('member-admin.score-history');
                }
            }
        }
    }
})();